module.exports = {
	"heartbeatTimeout": 30000
};


//////////////////
// WEBPACK FOOTER
// ./engines/html5/media-source/adapters/native-adapter-default-config.json
// module id = 67
// module chunks = 0


// WEBPACK FOOTER //
// core/engines/html5/media-source/adapters/native-adapter-default-config.json